import React, { ReactElement } from 'react';

import { AnimatedCounter } from '../../shared/AnimatedCounter/AnimatedCounter.component';

import styles from './DonorCounterContainer.styles.css';

export interface IDonorCounterContainerProps {
    donorCount: number;
    initialDonorCount?: number;
    delay?: number;
}

export function DonorCounterContainer (props: IDonorCounterContainerProps): ReactElement {
    const { initialDonorCount = 0, donorCount, delay = 250 }: IDonorCounterContainerProps = props;

    return (
        <div className="mt-3 mb-3">
            <h2 className={`${styles.header} text-gray-900 font-gellix text-base font-bold md:text-med`} data-testid="headline">
                Join today&apos;s&nbsp;
                <span className={`${styles.highlight} inline-block bg-yellow-500 text-lg align-middle text-gray-900 font-gellix font-bold md:text-xl`}>
                    {<AnimatedCounter start={initialDonorCount} end={donorCount} delay={delay} />} donors
                </span>
            </h2>
        </div>
    );
}
